import type { LucideIcon } from 'lucide-react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router';

import styles from './AudienceCard.module.css';

type AudienceCardEmphasis = 'muted' | 'primary';

interface AudienceCardProps {
  body: string;
  cta: string;
  ctaHref: string;
  emphasis?: AudienceCardEmphasis;
  icon: LucideIcon;
  title: string;
}

export function AudienceCard({
  body,
  cta,
  ctaHref,
  emphasis = 'primary',
  icon: Icon,
  title,
}: AudienceCardProps) {
  return (
    <Link className={styles.card} data-emphasis={emphasis} to={ctaHref}>
      <span className={styles.iconWrap}>
        <Icon aria-hidden="true" className={styles.icon} size={22} />
      </span>
      <div className={styles.body}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.copy}>{body}</p>
      </div>
      <span className={styles.cta}>
        <span>{cta}</span>
        <ArrowRight aria-hidden="true" size={16} />
      </span>
    </Link>
  );
}
